module.exports = __webpack_public_path__ + "img/2.38cd1227.png";